<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">


        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">

            <!-- Start type of Albums List -->
            <div class="page-content" *ngIf="viewShow">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-6">
                            <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.PROGRAM_LIST'"> </span></h3>
                        </div>
                        <div class="col-12 col-sm-6 position-relative">
                            <div class="filter-dropdown d-flex align-items-center justify-content-sm-end">
                                <ul class="mb-0 p-0">
                                    <li>
                                        <h6 class="title"><span [translate]="'GREATER.CREATE'"> </span></h6>
                                    </li>
                                    <li>
                                        <a class="ic-fill-btn d-flex" (click)="redirectCheck(1)">
                                            <i class="gricon gr_ic_plus"></i>
                                        </a>
                                    </li>
                                    <li class="dropdown dropdown-large filter-dropdown pt-3 pt-sm-0 d-none">
                                        <a class="ic-fill-btn d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="gricon gr_ic_filter"></i>
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-end dark-bg border-radius20">
                                            <div class="row align-items-center py-3 m-0">
                                                <div class="col-4">
                                                    <a href="javascript:void(0)"> Cancel </a>
                                                </div>
                                                <div class="col-4 text-center">
                                                    <h6 class="title m-0 white-color"> Filter </h6>
                                                </div>
                                                <div class="col-4 text-end">
                                                    <a href="javascript:void(0)"> Reset </a>
                                                </div>
                                            </div>
                                            <div class="p-3">
                                                <div class="custom-form">
                                                    <div class="custom-checkbox right-select-checkbox mb-2 py-2 px-3 border-radius5 darksecundary-bg">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="filtercheckbox1" id="FilterCheckbox1" checked>
                                                            <label class="form-check-label" for="FilterCheckbox1">Album</label>
                                                        </div>
                                                    </div>
                                                    <div class="custom-checkbox right-select-checkbox mb-2 py-2 px-3 border-radius5 darksecundary-bg">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="filtercheckbox1" id="FilterCheckbox2">
                                                            <label class="form-check-label" for="FilterCheckbox2">Program</label>
                                                        </div>
                                                    </div>
                                                    <div class="custom-checkbox right-select-checkbox mb-2 py-2 px-3 border-radius5 darksecundary-bg">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="filtercheckbox1" id="FilterCheckbox3">
                                                            <label class="form-check-label" for="FilterCheckbox3">Nutrition</label>
                                                        </div>
                                                    </div>
                                                    <div class="custom-checkbox right-select-checkbox mb-2 py-2 px-3 border-radius5 darksecundary-bg">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" name="filtercheckbox1" id="FilterCheckbox4">
                                                            <label class="form-check-label" for="FilterCheckbox4">Levels</label>
                                                        </div>
                                                    </div>
                                                    <div class="pt-5 pb-4 px-3 btn-box text-center">
                                                        <button type="submit" class="btn gradient1-btn custom-btn">Show Results </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->



                <!-- Section Wrap Start -->
                <section class="inner-section-wrap">

                    <!-- Table Block Start -->
                    <div class="table-wrap px-3 py-2 dark-bg border-radius20">
                        <!-- Tab Start -->
                        <div class="tab-wrap">
                            <div class="tab-header pb-4">
                                <div class="d-flex justify-content-start">
                                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="pills-all-tab" data-bs-toggle="pill" data-bs-target="#Alltab" type="button" role="tab" aria-controls="pills-all" aria-selected="true" (click)="types='';p=1;getDetail(1)"><span [translate]="'GREATER.ALL'"> </span></button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-review-tab" data-bs-toggle="pill" data-bs-target="#Reviewtab" type="button" role="tab" aria-controls="pills-review" aria-selected="false" (click)="types='4';p=1;getDetail(1)"><span [translate]="'GREATER.REVIEW'"> </span></button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-published-tab" data-bs-toggle="pill" data-bs-target="#Publishedtab" type="button" role="tab" aria-controls="pills-published" aria-selected="false" (click)="types='1';p=1;getDetail(1)"><span [translate]="'GREATER.PUBLISHED'"> </span></button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-unpublished-tab" data-bs-toggle="pill" data-bs-target="#Unpublishedtab" type="button" role="tab" aria-controls="pills-unpublished" aria-selected="false" (click)="types='2';p=1;getDetail(1)"><span [translate]="'GREATER.UNPUBLISHED'"> </span></button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="pills-denied-tab" data-bs-toggle="pill" data-bs-target="#Deniedtab" type="button" role="tab" aria-controls="pills-denied" aria-selected="false" (click)="types='3';p=1;getDetail(1)"><span [translate]="'GREATER.DENIED'"> </span></button>
                                        </li>
                                        <!-- <li class="nav-item" role="presentation"  *ngIf="loginDetail.user_role_type==3">
                                            <button class="nav-link" id="pills-share-tab" data-bs-toggle="pill" data-bs-target="#Sharetab" type="button" role="tab" aria-controls="pills-share" aria-selected="false" (click)="types='1';getDetail(1)"><span [translate]="'GREATER.SHARE'"> </span></button>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="Alltab" role="tabpanel" aria-labelledby="pills-all-tab">
                                    <!-- Table Start -->
                                    <div class="table-responsive table-block">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                                    <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                                    <th scope="col">
                                                        <span [translate]="'GREATER.PROGRAM_TITLE'"> </span>
                                                    </th>
                                                     <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                                     <th scope="col">
                                                        <span [translate]="'GREATER.PRICE'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.VIEWS'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.LIKES'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                                    </th>
                                                    <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                                    <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of programListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                                    <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                                    <td scope="row">
                                                        <img  loading="lazy"  class="video-img" [src]="item.program_image" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                                    </td>

                                                    <td>{{item.name}}</td>
                                                                                             <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
<td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>

                                                     <td>{{loginDetail.userCurrencySymbol }}{{item.price}}</td>
                                                    <td>{{item.view}}</td>
                                                    <td>{{item.likes}}</td>
                                                    <td>{{service.convertDate(item.createdAt)}}</td>
                                                    <td class="greenlight-color font-w-bold" *ngIf="item.status =='Published'">{{item.status}}</td>
                                                    <td class="text-warning font-w-bold" *ngIf="item.status =='Unpublished'">{{item.status}}</td>
                                                    <td class="orange-color font-w-bold" *ngIf="item.status =='Denied'">{{item.status}}</td>
                                                    <td class="text-info font-w-bold" *ngIf="item.status =='Review'"><span [translate]="'GREATER.REVIEW'"> </span></td>
                                                    <!-- <td class="white-color font-w-bold">Draft</td> -->
                                                    <td class="action-btn-box">
                                                        <a (click)="redirect(item,1)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_edit"></i></a>
                                                        <a (click)="redirect(item,2)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="pagination-block pt-4">
                                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="programListing.length > 0"></pagination-controls>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade" id="Reviewtab" role="tabpanel" aria-labelledby="pills-review-tab">
                                    <!-- Table Start -->
                                    <div class="table-responsive table-block">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                                    <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                                    <th scope="col">
                                                        <span [translate]="'GREATER.PROGRAM_TITLE'"> </span>
                                                    </th>
                                                     <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                                     <th scope="col">
                                                        <span [translate]="'GREATER.PRICE'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.VIEWS'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.LIKES'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                                    </th>
                                                    <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                                    <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of programListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                                    <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                                    <td scope="row">
                                                        <img  loading="lazy"  class="video-img" [src]="item.program_image" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                                    </td>

                                                    <td>{{item.name}}</td>
                                                                                             <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
<td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>

                                                     <td>{{loginDetail.userCurrencySymbol }}{{item.price}}</td>
                                                    <td>{{item.view}}</td>
                                                    <td>{{item.likes}}</td>
                                                    <td>{{service.convertDate(item.createdAt)}}</td>
                                                    <td class="text-info font-w-bold"><span [translate]="'GREATER.REVIEW'"> </span></td>
                                                    <td class="action-btn-box">
                                                        <a (click)="redirect(item,1)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_edit"></i></a>
                                                        <a (click)="redirect(item,2)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="pagination-block pt-4">
                                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="programListing.length > 0"></pagination-controls>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade" id="Publishedtab" role="tabpanel" aria-labelledby="pills-published-tab">
                                    <!-- Table Start -->
                                    <div class="table-responsive table-block">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                                    <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                                    <th scope="col">
                                                        <span [translate]="'GREATER.PROGRAM_TITLE'"> </span>
                                                    </th>
                                                     <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                                     <th scope="col">
                                                        <span [translate]="'GREATER.PRICE'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.VIEWS'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.LIKES'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                                    </th>
                                                    <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                                    <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of programListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                                    <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                                    <td scope="row">
                                                        <img  loading="lazy"  class="video-img" [src]="item.program_image" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                                    </td>

                                                    <td>{{item.name}}</td>
                                                                                             <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
<td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>

                                                     <td>{{loginDetail.userCurrencySymbol }}{{item.price}}</td>
                                                    <td>{{item.view}}</td>
                                                    <td>{{item.likes}}</td>
                                                    <td>{{service.convertDate(item.createdAt)}}</td>
                                                    <td class="greenlight-color font-w-bold">{{item.status}}</td>
                                                    <td class="action-btn-box">
                                                        <a (click)="redirect(item,1)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_edit"></i></a>
                                                        <a (click)="redirect(item,2)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="pagination-block pt-4">
                                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="programListing.length > 0"></pagination-controls>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade" id="Unpublishedtab" role="tabpanel" aria-labelledby="pills-unpublished-tab">
                                    <!-- Table Start -->
                                    <div class="table-responsive table-block">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                                    <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                                    <th scope="col">
                                                        <span [translate]="'GREATER.PROGRAM_TITLE'"> </span>
                                                    </th>
                                                     <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                                     <th scope="col">
                                                        <span [translate]="'GREATER.PRICE'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.VIEWS'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.LIKES'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                                    </th>
                                                    <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                                    <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of programListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                                    <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                                    <td scope="row">
                                                        <img  loading="lazy"  class="video-img" [src]="item.program_image" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                                    </td>
                                                    <td>{{item.name}}</td>                                                                                             
                                                    <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                                    <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
<td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>
                                                    <td>{{loginDetail.userCurrencySymbol }}{{item.price}}</td>
                                                    <td>{{item.view}}</td>
                                                    <td>{{item.likes}}</td>
                                                    <td>{{service.convertDate(item.createdAt)}}</td>
                                                    <td class="text-warning font-w-bold">{{item.status}}</td>
                                                    <td class="action-btn-box">
                                                        <a (click)="redirect(item,1)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_edit"></i></a>
                                                        <a (click)="redirect(item,2)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="pagination-block pt-4">
                                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail(p = $event)" class="text-center" *ngIf="programListing.length > 0"></pagination-controls>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade" id="Deniedtab" role="tabpanel" aria-labelledby="pills-denied-tab">
                                    <!-- Table Start -->
                                    <div class="table-responsive table-block">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                                    <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                                    <th scope="col">
                                                        <span [translate]="'GREATER.PROGRAM_TITLE'"> </span>
                                                    </th>
                                                     <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                                     <th scope="col">
                                                        <span [translate]="'GREATER.PRICE'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.VIEWS'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.LIKES'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                                    </th>
                                                    <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                                    <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of programListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                                    <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                                    <td scope="row">
                                                        <img  loading="lazy"  class="video-img" [src]="item.program_image" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                                    </td>

                                                    <td>{{item.name}}</td>
                                                                                             <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
<td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>

                                                     <td>{{loginDetail.userCurrencySymbol }}{{item.price}}</td>
                                                    <td>{{item.view}}</td>
                                                    <td>{{item.likes}}</td>
                                                    <td>{{service.convertDate(item.createdAt)}}</td>
                                                    <td class="orange-color font-w-bold">Denied</td>
                                                    <td class="action-btn-box">
                                                        <a (click)="redirect(item,1)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_edit"></i></a>
                                                        <a (click)="redirect(item,2)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="pagination-block pt-4">
                                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="programListing.length > 0"></pagination-controls>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade" id="Sharetab" role="tabpanel" aria-labelledby="pills-share-tab">
                                    <!-- Table Start -->
                                    <div class="table-responsive table-block">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                                    <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>

                                                    <th scope="col">
                                                        <span [translate]="'GREATER.PROGRAM_TITLE'"> </span>
                                                    </th>
                                                     <th scope="col"><span [translate]="'GREATER.PRODUCT'"> </span></th>
                                                     <th scope="col">
                                                        <span [translate]="'GREATER.PRICE'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.VIEWS'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.LIKES'"> </span>
                                                    </th>
                                                    <th scope="col">
                                                        <span [translate]="'GREATER.CREATED_AT'"> </span>
                                                    </th>
                                                    <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                                    <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                                    <th scope="col" *ngIf="Views"><span [translate]="'GREATER.APPROVED'"> </span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of programListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                                    <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                                    <td scope="row">
                                                        <img  loading="lazy"  class="video-img" [src]="item.program_image" style="height:100px;width:150px ;object-fit:contain ; background-color: #1a1d1f">
                                                    </td>

                                                    <td>{{item.name}}</td>
                                                                                             <td *ngIf="item.category_type==1"><span [translate]="'GREATER.STANDARD'"> </span></td>
                                        <td *ngIf="item.category_type==2"><span [translate]="'GREATER.NUTRITION'"> </span></td>
<td *ngIf="item.category_type==3"><span [translate]="'GREATER.HYBRID'"> </span></td>

                                                     <td>{{loginDetail.userCurrencySymbol }}{{item.price}}</td>
                                                    <td>{{item.view}}</td>
                                                    <td>{{item.likes}}</td>
                                                    <td>{{service.convertDate(item.createdAt)}}</td>
                                                    <td class="greenlight-color font-w-bold">{{item.status}}</td>
                                                    <td class="action-btn-box">
                                                        <a (click)="redirect(item,1)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_edit"></i></a>
                                                        <a (click)="redirect(item,2)" class="btn action-btn ic-fill-btn"><i class="gricon gr_ic_eye"></i></a>
                                                        <a (click)="Views=true" class="btn action-btn ic-fill-btn" *ngIf="!Views && item.collaborator.length ==0 "><i class="gricon gr_ic_plus"></i></a>
                                                        <a  (click)="RemoveREvenue($event,item._id)" class="btn action-btn ic-fill-btn" *ngIf="item.collaborator.length !=0 "><i class="gricon gr_ic_close"></i></a>

                                                    </td>
                                                    <td class="action-btn-box" *ngIf="Views && item.collaborator.length ==0 ">
                                                        <select class="form-select"(change)="setREvenue($event,item._id)">
                                                            <option value="" hidden selected disabled>Choose Organisation</option>
                                                            <option *ngFor="let ite of OrgList" [value]="ite.organizationId">{{ite.org[0].full_name}}</option>
                                                        </select>
                                                    </td>
                                                    <td *ngIf="item.collaborator.length !=0 ">
                                                       {{item.collaborator[0].full_name}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="pagination-block pt-4">
                                            <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="programListing.length > 0"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Tab End -->
                    </div>
                    <!-- Table Block End -->

                </section>
                <!-- Section Wrap End -->

            </div>
            <!-- Start type of Albums List -->




            <!-- Start type of Albums -->
            <div class="page-content" *ngIf="!viewShow">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <!-- <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.CREATE_A_NEW_PROGRAM'"> </span>  </h3> -->
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <!-- Section Wrap Start -->
                <section class="inner-section-wrap py-5">

                    <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 align-items-center justify-content-center">

                        <!-- start Coulam -->
                        <div class="col p-4">
                            <div class="card min-height-350 create-hover-card border-radius10">
                                <div class="card-body blank-card-body text-center">
                                    <h3 class="title m-0 pt-4 pb-3">
                                        <span [translate]="'GREATER.CREATE_PROGRAM'"> </span>?
                                    </h3>
                                    <div class="py-4">
                                        <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_b_455_2721)">
                                    <circle cx="41" cy="41" r="40" fill="white" fill-opacity="0.2"/>
                                    <circle cx="41" cy="41" r="40" stroke="white" stroke-width="2"/>
                                    </g>
                                    <mask id="mask0_455_2721" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="18" y="18" width="47" height="47">
                                    <rect x="18" y="18" width="47" height="47" fill="#004FEC"/>
                                    </mask>
                                    <g mask="url(#mask0_455_2721)">
                                    <path d="M29.3366 50.1804L29.3366 32.8176C29.3366 29.2616 33.201 27.03 36.2853 28.808L43.8147 33.1442L51.344 37.4985C54.4283 39.2765 54.4283 43.7215 51.344 45.4996L43.8147 49.8539L36.2853 54.19C33.201 55.9681 29.3366 53.7546 29.3366 50.1804Z" fill="white"/>
                                    </g>
                                    <defs>
                                    <filter id="filter0_b_455_2721" x="-27.1828" y="-27.1828" width="136.366" height="136.366" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="13.5914"/>
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_455_2721"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_455_2721" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                                    </div>
                                    <div class="btn-box pt-3 pb-4">
                                        <a (click)="redirectCheck(2)" class="btn custom-btn gradient1-btn"><span [translate]="'GREATER.CREATE_NOW'"> </span> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                    </div>

                </section>
                <!-- Section Wrap End -->

            </div>
            <!-- End type of Albums -->



        </div>

    </div>
    <app-footer></app-footer>
</main>

<button data-bs-toggle="modal" data-bs-target="#ProfilePost" id="passlink11" aria-hidden="true" data-keyboard="false" data-backdrop="static"  style="display: none;"> </button>
<div class="modal fade" id="ProfilePost" tabindex="-1" aria-labelledby="firstPostLabel" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius10">
            <div class="modal-body p-4">
                <div class="verify-header p-4 text-center">
                    <div class="py-4">
                        <img loading="lazy" src="../../../assets/images/inner_logo.png">
                    </div>

                    <div class="custom-form">
                        <form action="" autocomplete="off">
                            <h4 class="white-color">Profile set up  </h4>
                            <div class="pb-4">
                                <span class="white-color" *ngIf="loginDetail.is_default_profile_image">Let's start by uploading your profile photo.  </span>
                                <span class="white-color" *ngIf="!loginDetail.is_default_profile_image">Upload your profile photo  </span>
                            </div>
                            <div class="pb-1">
                                <span class="white-color" >Once that's done, please complete:  </span>
                            </div>
                            <div class="pb-4">
                                <span class="white-color" > Overview | Bank Account | Subscriptions </span>
                            </div>
                            <div class="form-btn-box text-center py-4">
                                <button type="submit" class="w-50 btn brandpurpal-btn custom-btn"  data-bs-dismiss="modal" data-bs-toggle="modal"  routerLink="/edit-profile" *ngIf="loginDetail.is_default_profile_image"><span [translate]="'GREATER.UPLOAD_PHOTO'" > </span></button>
                                <button type="submit" class="w-50 btn brandpurpal-btn custom-btn"  data-bs-dismiss="modal" ata-bs-toggle="modal" routerLink="/edit-profile" *ngIf="!loginDetail.is_default_profile_image"><span [translate]="'GREATER.UPLOAD_PROFILE'" > </span></button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>